import * as Immutable from 'immutable';
import * as React from 'react';

import { localeData } from '../../../locales/data';
import { addModifiers } from '../../../shared/helpers';
import { ErrorMsgIntl } from '../ErrorMsg';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

interface FieldSetProps {
  children: JSX.Element | JSX.Element[];
  errors?: Immutable.List<string>;
  modifiers?: string[];
  label?: string;
  id?: string;
  required?: boolean;
  renderRightTitle?: JSX.Element;
}

export const FieldSet = ({
  id,
  label,
  children,
  required = false,
  errors = Immutable.List(),
  modifiers = [],
  renderRightTitle,
}: FieldSetProps) => (
  <div className={addModifiers('form__field-set', modifiers)}>
    {label && (
      <label htmlFor={id} className={'form__label'}>
        <FormattedMessageHelper tagName="span" id={label} defaultMessage={localeData.en[label]} />
        {required && <sup>*</sup>}
        {renderRightTitle}
      </label>
    )}
    {children}
    <div className="input__error">{errors && errors.size !== 0 && <ErrorMsgIntl errors={errors} />}</div>
  </div>
);
